module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_arrow--light-blue-78f5e867b06b0dca471da0a7d98e28d6.svg";